const form = [
  {
    name: 'APP名称',
    key: 'appName',
    type: 'input',
  },
  {
    name: '联系我们',
    key: 'mobile',
    type: 'input',
  },
  {
    name: '版本号',
    type: 'input',
    key: 'versionNo',
  },
  {
    name: '版权中文',
    type: 'input',
    key: 'copyrightChn',
    maxLength: 999,
  },
  {
    name: '版权英文',
    type: 'input',
    key: 'copyrightEng',
  },
  {
    name: '关于我们',
    type: 'textArea',
    key: 'plateInfoDesc',
    rules: [
      {
        required: true,
        type: 'string',
      },
    ],
  },
  {
    name: 'LOGO图片（建议尺寸：80*80）像素',
    key: 'logoImgUrl',
    type: 'upload',
    maxLength: 1,
    cols: 24,
    rules: [
      {
        required: true,
        message: '请上传图片',
        type: 'string',
      },
    ],
  },
]
export default {
  type: 'form',
  url: '/config/farmPlateInfo/getById',
  edit: '/config/farmPlateInfo/update',
  data: form,
}
